// extracted by mini-css-extract-plugin
export default {"tooltip":"WP-z","arrow":"XP-z"};